/** V3 Sign in / VerifyEmail static asset paths (D19). */
export const SIGN_IN_PAGE_ASSETS = {
  logo: "/edgen_logo_full_v2.svg",
  verifyEmailBg: "/assets/images/auth/verify-email-bg.svg",
} as const;

/**
 * H5 flat auth layout safe-area tokens.
 * `/login` is immersive — RootLayoutClient does not apply `pt-safe`; pages self-handle.
 */
export const AUTH_H5_LAYOUT = {
  /** Immersive shell top inset (Sign in flat page). */
  signInShellTopClass: "pt-safe",
  /**
   * VerifyEmail content column top: status-bar safe area + 15px Figma gap (96154:99635).
   */
  verifyEmailContentTopClass:
    "pt-[calc(var(--safe-area-inset-top,0px)+15px)] md:pt-0",
} as const;
